module.exports = __webpack_public_path__ + "static/Product-Summary-P6-Outdoor-e2ff02eaa222a4f79624f8598a074978.jpg";